module.exports = {"140681100":"云中镇","140681101":"吴家窑镇","140681102":"金沙滩镇","140681103":"毛家皂镇","140681200":"何家堡乡","140681201":"新家园乡","140681202":"亲和乡","140681203":"海北头乡","140681204":"马辛庄乡","140681205":"河头乡","140681500":"金沙滩农牧场","140681501":"金沙滩林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140681.json
// module id = 321
// module chunks = 0